import React from "react";
import P from "prop-types";
import styled from "@emotion/styled";
import { Field } from "formik";

const Checkbox = ({ name, label, subLabel, tip, disabled }) => (
	<Field name={name}>
		{({ field} ) => (
			<div className="form-group ">
				{/* <p className='col-form-label col-lg-3 col-sm-12'>{label} : </p>
        <div className='col-lg-9 col-md-9 col-sm-12'>
          <div className='kt-checkbox-inline'>
            <label htmlFor={field.name} className='kt-checkbox'>
              <Input
                id={field.name}
                type='checkbox'
                checked={field.value}
                {...field}
                disabled={disabled}
              />
              {subLabel}
              <span />
            </label>
          </div>
          {tip && !field.value && (
            <Feedback className='invalid-feedback'>{tip}</Feedback>
          )}
        </div> */}
				<div className="custom-control custom-checkbox" style={{padding: 0}}>
					<Input
						onChange={(setValue) => {
							
						}}	
						{...field}
						disabled={disabled}
						type="checkbox"
						className="custom-control-input"
						id={field.name}
						checked={field.value}
						value={field.value}
					/>
					<label className="custom-control-label" htmlFor={field.name}>
						{label}
					</label>
				</div>
				{tip && !field.value && (
					<Feedback className="invalid-feedback">{tip}</Feedback>
				)}
			</div>
		)}
	</Field>
);

const Input = styled.input`
	position: relative !important;
`;

const Feedback = styled.div`
	display: block;
	margin-top: 0;
	position: absolute;
	top: 100%;
	opacity: 1;
	transition: 0.2s !important;

	&:empty {
		opacity: 0;
	}
`;

Checkbox.propTypes = {
	name: P.string.isRequired,
	label: P.string.isRequired,
	subLabel: P.string,
	tip: P.string,
	disabled: P.bool,
};

Checkbox.defaultProps = {
	subLabel: "",
	tip: "",
	disabled: false,
};

export default Checkbox;
